<template>
    <div>
        <input
            type="radio"
            :id="id"
            :name="name"
            class="payment-type custom-control-input"
            :value="value"
            :checked="value === checkedValue"
            @change="changeInput($event)"
            @input="updateInput($event)">
        <label
            @click="emitClick($event)"
            class="custom-control-label"
            :for="id">
        {{ text }}
    </label>
    </div>
</template>

<script>
export default {
    name: 'Radio',
    props: ['value', 'id', 'text', 'name', 'checkedValue'],
    methods: {
        changeInput (e) {
            this.$emit('change', this.checkedValue)
        },
        updateInput (e) {
            this.$emit('input', this.checkedValue)
        },
        emitClick (e) {
            this.$emit('click', this.checkedValue)
        }
    }
}
</script>
